import swal from "sweetalert";
import {
    updateProfile,
} from '../../services/ProfileService';

import {
    LOADING_PROFILE,
    UPDATE_PROFILE,
} from '../constants';

import * as utility from '../../utility/Utility';
import { globalLoadingAction } from '../actions/GlobalAction';
import { updateProfileAction } from '../actions/AuthActions';


export function updateProfileDetails(country, countryCode, firstName, lastName, phone, role, rate, hour, file, history) {
    return (dispatch) => {
        updateProfile(country, countryCode, firstName, lastName, phone, role, rate, hour, file)
            .then((response) => {
                console.log('response', response.data);
                if (response.data.status == 200) {
                    // dispatch(updateProfileAction({ "country": country, "country_code": countryCode, "first_name": firstName, "last_name": lastName, "phone_no": phone, "designation": role, "profile_pic": file }));
                    dispatch(updateProfileDetailsAction(response.data.data));
                    dispatch(updateProfileAction(response.data.data));
                    utility.showSuccess(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function updateProfileDetailsAction(data) {
    return {
        type: UPDATE_PROFILE,
        payload: data,
    };
}
export function loadingProfileAction(status) {
    return {
        type: LOADING_PROFILE,
        payload: status,
    };
}
